import React from "react";
import { Avatar, Typography } from "antd";
import { getAgeByDate } from "../../../components/util/helpers";

const { Title, Text } = Typography;
const PatientDetails = (props) => {
  const { record } = props;
  const letter = record && record.first_name ? record.first_name.charAt(0) : "";
  const employeeAge =
    record && record.birthday ? getAgeByDate(record.birthday) : null;
  const arr = [`${record.surename} ${record.first_name}`];
  if (employeeAge) {
    arr.push(employeeAge);
  }
  const name = record ? arr.join(", ") : "";
  return record ? (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "max-content",
        alignItems: "flex-end",
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {record && record.avatar_url ? (
          <Avatar
            style={{ width: "50px", height: "50px" }}
            src={record.avatar_url}
          />
        ) : (
          <Avatar
            style={{
              color: "#f56a00",
              backgroundColor: "#fde3cf",
              width: "50px",
              height: "50px",
            }}
          >
            {letter}
          </Avatar>
        )}
        <div style={{ width: "20px", height: "20px" }} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Title level={3} style={{ margin: 0 }}>
            {name}
          </Title>
          <Text>{record.local_id_number}</Text>
        </div>
      </div>
    </div>
  ) : null;
};

export default PatientDetails;
